<div
    class="w-full p-4 flex flex-col justify-start items-center rounded-lg border-latte border gap-1 cursor-pointer"
    [ngClass]="{ 'bg-primary-50 border-primary-500': selected, 'hover:bg-stone-50': !selected }">
    @if (isRandomCommunityMemberSlot) {
        <div
            class="w-9 h-9 flex flex-col justify-center items-center border rounded-lg bg-white border-latte mr-auto">
            <i class="pi pi-globe text-color" style="font-size: 18px"></i>
        </div>
        <div class="flex flex-col justify-start items-start gap-1 w-full">
            <div
                class="block truncate text-left text-color text-14 leading-[normal] font-medium font-inter">
                Focusmate community
            </div>
            <div
                class="block text-left text-12 leading-[normal] text-muted-color font-normal font-inter">
                We’ll randomly match you with a Focusmate
                <span class="text-nowrap">community member</span>
            </div>
        </div>
    } @else {
        <div class="w-full flex flex-row justify-between items-start">
            <fm-avatar
                [isSnoozed]="snoozed"
                [isSaved]="saved"
                [isQuietMode]="quietMode"
                [avatarLocation]="profileImage"
                size="xl">
            </fm-avatar>
            <p-button
                size="small"
                (click)="onUserProfileSelected()"
                severity="secondary"
                styleClass="!w-[24px] aspect-square !rounded"
                icon="pi pi-id-card" />
        </div>
        <div class="flex flex-col justify-start items-start gap-1 w-full">
            <div class="flex flex-row w-full justify-start items-center">
                <div
                    class="block truncate max-w-full text-left text-color text-14 leading-[normal] font-medium font-inter">
                    {{ displayName }}
                </div>
                <fm-activity-type-icon
                    class="inline-flex mr-0.5 text-[13px]"
                    [activityType]="activityType"
                    showTooltip="true"
            /></div>
            <div
                class="block truncate text-left text-12 leading-[normal] text-muted-color font-normal font-inter">
                {{ sessionsInfo }}
            </div>
            <div
                *ngIf="lastMet"
                class="block truncate text-left text-12 leading-[normal] text-muted-color font-normal font-inter"
                >{{ lastMet }}</div
            >
            <div
                class="block truncate text-left text-12 leading-[normal] text-muted-color font-normal font-inter"
                >{{ timezoneAndTime }}</div
            >
        </div>
    }
</div>
